import { ProductType } from '@/shared/enums';

export default {
  data() {
    return {
      time: this.$services.resolve('time'),
      manager: this.$services.resolve('liveManager'),
      channel: undefined,
      selectedDay: undefined,
    };
  },
  watch: {
    currentDay: 'loadEpg',
    player: 'onPlayer',
    'time.now': function () {
      const currentDay = this.time.now.startOf('day').valueOf();
      if (this.currentDay !== currentDay) {
        this.currentDay = currentDay;
      }
    },
  },
  methods: {
    onPlayer() {
      if (this.player) {
        if (this.product.type === ProductType.LIVE) {
          /* player has no once event
            this.player.once('playing', () => this.loadEpg());
          */

          this.player.on('playing', () => this.loadEpg());
          this.player.on('startOverButtonClicked', () => {
            const program = this.getCurrentProgram();
            if (program && program.startoverAvailable) {
              this.player.seekTo((program.since - this.player.getTimeShiftStart()) / 1000);
            }
          });
        }
      }
    },
    getCurrentProgram() {
      const currentPlayTime = this.player.getTimeShiftStart() + this.player.getCurrentTime() * 1000;
      const [program] = this.manager.getSince(this.time, { since: currentPlayTime, till: currentPlayTime }, this.product);
      return program;
    },
    loadEpg() {
      const now = this.time.now;
      const since = now.startOf('day').valueOf();
      const till = now.endOf('day').valueOf();
      this.manager.fillPrograms([this.product], since, till);
    },
  },
};
